import { graphql } from '@graphql/__generated'

export const SET_USER_DATA = graphql(`
  mutation SetUserData($input: SetUserDataInput!) {
    setUserData(input: $input)
  }
`)
